import React from 'react';
import { testimonials } from '../data/content';
export function TestimonialsSection() {
  return <section className="w-full bg-ink-800 px-4 py-10 sm:px-6 sm:py-14" data-id="element-159" data-mp="20rytduv6tzic">
      <div className="mx-auto max-w-5xl" data-id="element-160" data-mp="1n00pbygc2tt1">
        <h2 className="text-center text-lg font-extrabold uppercase text-white sm:text-2xl" data-id="element-161" data-mp="1myzf1w756bcd">
          Más comerciantes que ya lo tienen
        </h2>

        <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-162" data-mp="1qz9kn7r0uzqp">
          {testimonials.map(item => <li key={item.initials} data-id="element-163" data-mp="1i0o41i541usk">
              <figure className="flex h-full flex-col rounded-xl border border-white/10 bg-ink-700 p-4" data-id="element-164" data-mp="1i1qtdlmsbp6d">
                <div className="flex items-center gap-2.5" data-id="element-165" data-mp="142r3kanjd48m">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gold-500 text-xs font-extrabold text-ink-900" data-id="element-166" data-mp="18289f56vk3eb">
                    {item.initials}
                  </span>
                  <div data-id="element-167" data-mp="32h2hqysrpu08">
                    <span className="block text-xs text-gold-400" data-id="element-168" data-mp="32fhkh1f2jwyo">★★★★★</span>
                    <span className="block text-[13px] font-extrabold text-white" data-id="element-169" data-mp="2v0sun8y4a43d">
                      {item.name}
                    </span>
                  </div>
                </div>
                <blockquote className="mt-3 text-[13px] leading-relaxed text-neutral-300" data-id="element-170" data-mp="34rx8u6fyxkx5">
                  {item.quote}
                </blockquote>
              </figure>
            </li>)}
        </ul>
      </div>
    </section>;
}